module.exports = __webpack_public_path__ + "static/media/Hollow-Bar.9fc246e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Hollow-Bar.png
// module id = 340
// module chunks = 0